import(/* webpackMode: "eager" */ "/tmp/8dee404febc7785/app/[locale]/error.tsx");
